import React from 'react';
import { Link } from 'react-router-dom';

const ModernHome = ({ jwtToken }) => {
  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ marginBottom: '2rem' }}>
        <h2 style={{ 
          color: 'var(--text-primary)', 
          marginBottom: '1rem', 
          fontSize: '1.75rem', 
          fontWeight: '600'
        }}>
          Start now to be Better by December
        </h2>
        <p style={{ 
          color: 'var(--text-secondary)', 
          fontSize: '1rem', 
          lineHeight: '1.6', 
          maxWidth: '600px', 
          margin: '0 auto'
        }}>
          Every January, many people make resolutions for the New Year. Goals and
          resolutions are more likely to be achieved if measured and tracked. The
          purpose of this site is to track progress so that goals can be met and
          resolutions accomplished. By doing this, anyone can be Better by
          December.
        </p>
      </div>

      {jwtToken === "" && (
        <div style={{ 
          display: 'flex', 
          gap: '1rem', 
          justifyContent: 'center', 
          flexWrap: 'wrap'
        }}>
          <Link to="/login" className="modern-btn">
            Login
          </Link>
          <Link to="/register" className="modern-btn modern-btn-secondary">
            Register
          </Link>
        </div>
      )}
    </div>
  );
};

export default ModernHome;